import { apiRoutes } from '@features/campaigns/shared/consts/apiRoutes.ts';
import { CampaignDetails } from '@features/campaigns/shared/types/campaign.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { CampaignId } from '@shared/types/campaign.ts';

export async function deleteCampaign(campaignId: CampaignId): Promise<CampaignDetails | null> {
  return await apiClient.delete<never, CampaignDetails>(apiRoutes.deleteCampaign(campaignId));
}
